import {Scanner} from "../../entities/Scanner";
import {EditBaseCtrl} from "./EditBaseCtrl";
import {EditScannerModel} from "../../models/edit/EditScannerModel";
import {NotificationService} from "../../services/NotificationService";
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditScannerCtrl extends EditBaseCtrl<Scanner> {
    public static $inject = ['$scope','$state','$stateParams','$uibModal','EditScannerModel','NotificationService'];
    constructor(public $scope:any, public stateService:StateService,
                public stateParamsService:StateParams,
                public modal:angular.ui.bootstrap.IModalService,
                public editModel:EditScannerModel,
                public notifyService:NotificationService) {
        super($scope, stateService, stateParamsService,notifyService, editModel);
        $scope.vm = this;
        this.loadData().then((ok) => {
        });
    }
    save():void{
        this.model.saveData().then((ok)=>{
            if(ok)
              this.stateService.go("admin.scanners");
        }).catch((exc)=>{
          this.notifyService.notifyError(exc);
        });
    }
    cancel():void{
        this.stateService.go("admin.scanners");
    }    
}
